import type { Icon as LucideIcon } from '@phosphor-icons/react'

type Props = {
  module: string
  Icon: LucideIcon
  description: string
  comingFeatures: string[]
}

/**
 * Placeholder reusable para los módulos NeoCore que todavía no
 * están implementados. Muestra qué va a vivir en ese módulo para
 * que el operador entienda el alcance sin sorpresas.
 */
export function NeoCoreModulePlaceholder({ module, Icon, description, comingFeatures }: Props) {
  return (
    <div
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)',
        padding: '40px 32px',
        boxShadow: 'var(--shadow-sm)',
        maxWidth: 720,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 'var(--radius-md)',
            background: 'var(--brand-50)',
            color: 'var(--brand-600)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon size={22} weight="duotone" />
        </div>
        <div>
          <h2 style={{ fontSize: 20, fontWeight: 600, margin: 0, color: 'var(--n-900)' }}>
            {module}
          </h2>
          <p style={{ fontSize: 13, margin: '4px 0 0', color: 'var(--n-500)' }}>
            Módulo NeoCore · próximamente
          </p>
        </div>
      </div>

      <p style={{ fontSize: 14, color: 'var(--n-700)', margin: '0 0 24px', lineHeight: 1.6 }}>
        {description}
      </p>

      <div
        style={{
          background: 'var(--bg)',
          borderRadius: 'var(--radius-md)',
          padding: '16px 20px',
        }}
      >
        <h3
          style={{
            fontSize: 12,
            fontWeight: 600,
            margin: '0 0 12px',
            color: 'var(--n-600)',
            textTransform: 'uppercase',
            letterSpacing: 0.4,
          }}
        >
          Qué va a vivir acá
        </h3>
        <ul
          style={{
            margin: 0,
            paddingLeft: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          {comingFeatures.map((f, i) => (
            <li key={i} style={{ fontSize: 13, color: 'var(--n-700)', lineHeight: 1.5 }}>
              {f}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
